<template>
  <div>
    <input ref="excel-upload-input" class="excel-upload-input" type="file" accept=".xlsx, .xls" @change="handleClick">
    <div class="drop btn blue" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
   <span>
       {{$t('excel.dropExcelFiles')}}
   </span>
      <button style="margin-left:16px;" size="mini" type="primary" class="btn-lit-blue btn-success" @click="handleUpload">
        <span>
            {{$t('excel.browse')}}
        </span>
          <span class="d-none">
                Import Fare Upload
          </span>
      </button>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import BaseConfiguration from "../../config/base.js";
import { COMPONENT_NAME } from '../../util/constants';



export default {
  name:COMPONENT_NAME.UPLOAD_EXCEL,
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function// eslint-disable-line
  },
  data() {
    return {
      loading: false,
      excelData: {
        header: null,
        results: null
      }
    }
  },
  methods: {
    generateData({ header, results }) {
        try {
            if (BaseConfiguration.isDebug) console.log("generateData");

      this.excelData.header = header
      this.excelData.results = results
      this.onSuccess && this.onSuccess(this.excelData)
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in generateData",
                  err.toString(),
                  "generateData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    handleDrop(e) {
          try {
                  if (BaseConfiguration.isDebug) console.log("handleDrop");
 let options = {
    html: true, 
    loader: true, 
    okText: this.$t('excel.okBtn'),
    // cancelText: this.$t('excel.close'),
    animation: 'bounce'
};
      e.stopPropagation()
      e.preventDefault()
      if (this.loading) return
      const files = e.dataTransfer.files
      if (files.length !== 1) {        
        this.$dialog.alert('<stong>'+this.$t('excel.supportOneFile')+'</stong><div></div>',options)                    
                    .then(function (dialog) {
                      dialog.close();
                        //OK handler
                    })
                    .catch(function () {
                        //log
                    });
        return
      }
      const rawFile = files[0] // only use files[0]

      if (!this.isExcel(rawFile)) {
        // console.error(this.$dialog.globalOptions.okText)
        // this.$dialog.globalOptions.okText='Continue'
        let options = {
    html: true, 
    loader: true, 
    okText:this.$t('excel.okBtn'),
    // cancelText: this.$t('excel.close'),
    animation: 'bounce'
};
         this.$dialog.alert('<stong>'+this.$t('excel.onlySupportFormats')+'</stong><div></div>',options)                    
                    .then(function (dialog) {
                        //OK handler
                        dialog.close();
                    })
                    .catch(function () {
                        //log
                    });        
        return false
      }
      this.upload(rawFile)
      e.stopPropagation()
      e.preventDefault()
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in handleDrop",
                  err.toString(),
                  "handleDrop",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    handleDragover(e) {
       try {
                        if (BaseConfiguration.isDebug) console.log("handleDragover");

      e.stopPropagation()
      e.preventDefault()
      e.dataTransfer.dropEffect = 'copy'
      }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in handleDragover",
                  err.toString(),
                  "handleDragover",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    handleUpload() {
      try {
          if (BaseConfiguration.isDebug) console.log("handleUpload");
      this.$refs['excel-upload-input'].click()
      }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in handleUpload",
                  err.toString(),
                  "handleUpload",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    handleClick(e) {
        try {
          if (BaseConfiguration.isDebug) console.log("handleClick");

      const files = e.target.files
      const rawFile = files[0] // only use files[0]
      if (!rawFile) return
      this.upload(rawFile)
      }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in handleClick",
                  err.toString(),
                  "handleClick",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    upload(rawFile) {
          try {
      if(BaseConfiguration.isDebug) console.log("upload");
      this.$refs['excel-upload-input'].value = null // fix can't select the same excel

      if (!this.beforeUpload) {
        this.readerData(rawFile)
        return
      }
      const before = this.beforeUpload(rawFile)
      if (before) {
        this.readerData(rawFile)
      }
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in upload",
                  err.toString(),
                  "upload",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    readerData(rawFile) {
         try {
      if(BaseConfiguration.isDebug) console.log("readerData");
      this.loading = true
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => {
          const data = e.target.result
          const workbook = XLSX.read(data, { type: 'array' })
          const firstSheetName = workbook.SheetNames[0]
          const worksheet = workbook.Sheets[firstSheetName]
          const header = this.getHeaderRow(worksheet)
          const results = XLSX.utils.sheet_to_json(worksheet)
          this.generateData({ header, results })
          this.loading = false
          resolve()
        }
        reader.readAsArrayBuffer(rawFile)
      })
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in readerData",
                  err.toString(),
                  "readerData",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    getHeaderRow(sheet) {
         try {
      if(BaseConfiguration.isDebug) console.log("getHeaderRow");
      const headers = []
      const range = XLSX.utils.decode_range(sheet['!ref'])
      let C
      const R = range.s.r
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) { /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })]
        /* find the cell in the first row */
        let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell)
        headers.push(hdr)
      }
      return headers
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in getHeaderRow",
                  err.toString(),
                  "getHeaderRow",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    },
    isExcel(file) {
       try {
      if(BaseConfiguration.isDebug) console.log("isExcel");
      return /\.(xlsx|xls|csv)$/.test(file.name)
       }catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.UPLOAD_EXCEL,
                  "error in isExcel",
                  err.toString(),
                  "isExcel",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
    }
    
  }
}
</script>

<style scoped>
.excel-upload-input{
  display: none;
  z-index: -9999;
}
.drop{
  border: 2px dashed #bbb;
  width: 600px;
  height: 160px;
  line-height: 160px;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>
